module.exports = __webpack_public_path__ + "static/media/join_end_banner.7b2dc0c8.png";